module.exports = __webpack_public_path__ + "img/dffc913.jpg";